<template>
    <div class="modal fade" id="cartModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl modal-dialog-centered cart-modal" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Jouw winkelmandje
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!--<div class="alert alert-danger" role="alert">
                        Let op: In verband met vakanties worden er 17 juni - 9 juli geen bestellingen behandeld. Bestellingen die in deze periode worden geplaatst worden daarna pas weer behandeld.
                    </div>-->
                    <transition-group name="fade">
                        <div class="table-responsive" v-if="orderFormStep === 1" key="stepOne">
                            <table class="table table-image">
                                <thead>
                                <tr>
                                    <th scope="col" class="d-none d-lg-table-cell"></th>
                                    <th scope="col">Product</th>
                                    <th scope="col" class="d-none d-sm-table-cell">Prijs</th>
                                    <th scope="col">Aantal</th>
                                    <th scope="col">Totaal</th>
                                    <th scope="col"><span class="d-none d-sm-inline">Acties</span></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item, key) in this.cart.items">
                                    <td class="cart-image d-none d-lg-table-cell">
                                        <img :src="item.product.image" alt="" class="img-fluid" width="400">
                                    </td>
                                    <td>
                                        {{ item.product.title }}<br>
                                        <small class="text-muted d-none d-md-inline" v-html="item.product.htmlText"></small>
                                    </td>
                                    <td class="d-none d-sm-table-cell">
                                        &euro;{{ cart.parsePrice(item.product.getBasePriceForQuantity(item.quantity)) }}
                                        <small class="sub color-primary" v-if="item.priceTableItem !== null">Staffelkorting</small>
                                    </td>
                                    <td class="qty">
                                        <input type="text"
                                               class="form-control"
                                               @keyup="updateQuantity($event, item)"
                                               id="input1"
                                               :value="item.quantity">
                                    </td>
                                    <td>
                                        €{{ cart.parsePrice(item.price) }}
                                    </td>
                                    <td>
                                        <a class="p-2" @click="removeFromCart($event, key)" title="Verwijder uit winkelmandje">
                                            <i class="fad fa-times"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="float-end price" v-if="cart.items.length > 0">
                                <h6 class="d-flex justify-content-between">Subtotaal: <span>&nbsp; &euro; {{ cart.parsePrice(cart.getSubtotal()) }}</span></h6>
                                <h6 class="d-flex justify-content-between">Verzendkosten: <span>&nbsp; &euro; {{ cart.parsePrice(cart.getShipping()) }}</span></h6>
                                <h6 class="d-flex justify-content-between">BTW: <span>&nbsp; &euro; {{ cart.parsePrice(cart.getVat()) }}</span></h6>
                                <h5 class="d-flex justify-content-between">Totaal: <span>&nbsp; &euro; {{ cart.parsePrice(cart.getPrice()) }}</span></h5>
                            </div>
                        </div>
                        <div v-if="orderFormStep === 2" key="stepTwo">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-floating mb-3">
                                        <input type="text" :class="'form-control' + ('checkout.firstName' in this.formErrors && this.formErrors['checkout.firstName'] ? ' is-invalid' : '')"
                                               placeholder="Voornaam" v-model="checkout.firstName" id="firstName" name="firstName">
                                        <label for="firstName">Voornaam</label>
                                        <div class="invalid-feedback" v-if="'checkout.firstName' in this.formErrors && this.formErrors['checkout.firstName']">
                                            Dit is een verplicht veld
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-floating mb-3">
                                        <input type="text"
                                               :class="'form-control' + ('checkout.lastName' in this.formErrors && this.formErrors['checkout.lastName'] ? ' is-invalid' : '')"
                                               placeholder="Achternaam" v-model="checkout.lastName" id="lastName" name="lastName">
                                        <label for="lastName">Achternaam</label>
                                        <div class="invalid-feedback" v-if="'checkout.lastName' in this.formErrors && this.formErrors['checkout.lastName']">
                                            Dit is een verplicht veld
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-floating mb-3">
                                <input type="email"
                                       :class="'form-control' + ('checkout.email' in this.formErrors && this.formErrors['checkout.email'] ? ' is-invalid' : '')"
                                       placeholder="voornaam.achternaam@gmail.com" v-model="checkout.email" id="email" name="email">
                                <label for="email">E-mail</label>
                                <div class="invalid-feedback" v-if="'checkout.email' in this.formErrors && this.formErrors['checkout.email']">
                                    Dit is een verplicht veld
                                </div>
                            </div>
                            <div class="form-floating mb-3">
                                <input type="text"
                                       :class="'form-control' + ('checkout.phone' in this.formErrors && this.formErrors['checkout.phone'] ? ' is-invalid' : '')"
                                       placeholder="Telefoonnummer" v-model="checkout.phone" id="phone" name="phone">
                                <label for="phone">Telefoonnummer</label>
                                <div class="invalid-feedback" v-if="'checkout.phone' in this.formErrors && this.formErrors['checkout.phone']">
                                    Dit is een verplicht veld
                                </div>
                            </div>
                            <hr>
                            <h5>Factuuradres</h5>
                            <div class="form-floating mb-3">
                                <input type="text"
                                       :class="'form-control' + ('checkout.invoiceAddress.companyName' in this.formErrors && this.formErrors['checkout.invoiceAddress.companyName'] ? ' is-invalid' : '')"
                                       placeholder="Bedrijfsnaam" v-model="checkout.invoiceAddress.companyName" id="companyName" name="companyName">
                                <label for="companyName">Bedrijfsnaam</label>
                                <div class="invalid-feedback" v-if="'checkout.invoiceAddress.companyName' in this.formErrors && this.formErrors['checkout.invoiceAddress.companyName']">
                                    Dit is een verplicht veld
                                </div>
                            </div>
                            <div class="form-floating mb-3">
                                <input type="text"
                                       :class="'form-control' + ('checkout.invoiceAddress.costCenter' in this.formErrors && this.formErrors['checkout.invoiceAddress.costCenter'] ? ' is-invalid' : '')"
                                       placeholder="Kostenplaats" v-model="checkout.invoiceAddress.costCenter" id="costCenter" name="costCenter">
                                <label for="costCenter">Kostenplaats</label>
                                <div class="invalid-feedback" v-if="'checkout.invoiceAddress.costCenter' in this.formErrors && this.formErrors['checkout.invoiceAddress.costCenter']">
                                    Dit is een verplicht veld
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-floating mb-3">
                                        <input type="text"
                                               :class="'form-control' + ('checkout.invoiceAddress.street' in this.formErrors && this.formErrors['checkout.invoiceAddress.street'] ? ' is-invalid' : '')"
                                               placeholder="Straat" v-model="checkout.invoiceAddress.street" id="street" name="street">
                                        <label for="street">Straat</label>
                                        <div class="invalid-feedback" v-if="'checkout.invoiceAddress.street' in this.formErrors && this.formErrors['checkout.invoiceAddress.street']">
                                            Dit is een verplicht veld
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-floating mb-3">
                                        <input type="text"
                                               :class="'form-control' + ('checkout.invoiceAddress.streetNo' in this.formErrors && this.formErrors['checkout.invoiceAddress.streetNo'] ? ' is-invalid' : '')"
                                               placeholder="(huis)nummer" v-model="checkout.invoiceAddress.streetNo" id="streetNo" name="streetNo">
                                        <label for="streetNo">(huis)nummer</label>
                                        <div class="invalid-feedback" v-if="'checkout.invoiceAddress.streetNo' in this.formErrors && this.formErrors['checkout.invoiceAddress.streetNo']">
                                            Dit is een verplicht veld
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-floating mb-3">
                                        <input type="text"
                                               :class="'form-control' + ('checkout.invoiceAddress.streetNoAddition' in this.formErrors && this.formErrors['checkout.invoiceAddress.streetNoAddition'] ? ' is-invalid' : '')"
                                               placeholder="Toevoeging" v-model="checkout.invoiceAddress.streetNoAddition" id="streetNoAddition"
                                               name="streetNoAddition">
                                        <label for="streetNoAddition">Toevoeging</label>
                                        <div class="invalid-feedback"
                                             v-if="'checkout.invoiceAddress.streetNoAddition' in this.formErrors && this.formErrors['checkout.invoiceAddress.streetNoAddition']">
                                            Dit is een verplicht veld
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="form-floating mb-3">
                                        <input type="text"
                                               :class="'form-control' + ('checkout.invoiceAddress.zipcode' in this.formErrors && this.formErrors['checkout.invoiceAddress.zipcode'] ? ' is-invalid' : '')"
                                               placeholder="Postcode" v-model="checkout.invoiceAddress.zipcode" id="zipcode" name="zipcode">
                                        <label for="zipcode">Postcode</label>
                                        <div class="invalid-feedback" v-if="'checkout.invoiceAddress.zipcode' in this.formErrors && this.formErrors['checkout.invoiceAddress.zipcode']">
                                            Dit is een verplicht veld
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-8">
                                    <div class="form-floating mb-3">
                                        <input type="text"
                                               :class="'form-control' + ('checkout.invoiceAddress.city' in this.formErrors && this.formErrors['checkout.invoiceAddress.city'] ? ' is-invalid' : '')"
                                               placeholder="Plaats" v-model="checkout.invoiceAddress.city" id="city" name="city">
                                        <label for="city">Plaats</label>
                                        <div class="invalid-feedback" v-if="'checkout.invoiceAddress.city' in this.formErrors && this.formErrors['checkout.invoiceAddress.city']">
                                            Dit is een verplicht veld
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bg-secondary rounded p-2 mb-3">
                                <div class="form-check">
                                    <input class="form-check-input" name="sameAsInvoice" v-model="checkout.deliveryAddress.sameAsInvoice" type="checkbox" value="1" id="sameAsInvoice">
                                    <label class="form-check-label sub" for="sameAsInvoice">
                                        Verstuur naar hetzelfde adres
                                    </label>
                                </div>
                            </div>
                            <transition name="slide">
                                <div v-if="!checkout.deliveryAddress.sameAsInvoice">
                                    <h5>Bezorgadres</h5>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-floating mb-3">
                                                <input type="text"
                                                       :class="'form-control' + ('checkout.deliveryAddress.firstName' in this.formErrors && this.formErrors['checkout.deliveryAddress.firstName'] ? ' is-invalid' : '')"
                                                       placeholder="Voornaam" v-model="checkout.deliveryAddress.firstName" id="deliveryFirstName" name="deliveryFirstName">
                                                <label for="deliveryFirstName">Voornaam</label>
                                                <div class="invalid-feedback" v-if="'checkout.deliveryAddress.firstName' in this.formErrors && this.formErrors['checkout.deliveryAddress.firstName']">
                                                    Dit is een verplicht veld
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-floating mb-3">
                                                <input type="text"
                                                       :class="'form-control' + ('checkout.deliveryAddress.lastName' in this.formErrors && this.formErrors['checkout.deliveryAddress.lastName'] ? ' is-invalid' : '')"
                                                       placeholder="Achternaam" v-model="checkout.deliveryAddress.lastName" id="deliveryLastName" name="deliveryLastName">
                                                <label for="deliveryLastName">Achternaam</label>
                                                <div class="invalid-feedback" v-if="'checkout.deliveryAddress.lastName' in this.formErrors && this.formErrors['checkout.deliveryAddress.lastName']">
                                                    Dit is een verplicht veld
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-floating mb-3">
                                        <input type="text"
                                               :class="'form-control' + ('checkout.deliveryAddress.companyName' in this.formErrors && this.formErrors['checkout.deliveryAddress.companyName'] ? ' is-invalid' : '')"
                                               placeholder="Bedrijfsnaam" v-model="checkout.deliveryAddress.companyName" id="deliveryCompanyName"
                                               name="deliveryCompanyName">
                                        <label for="deliveryCompanyName">Bedrijfsnaam</label>
                                        <div class="invalid-feedback" v-if="'checkout.deliveryAddress.companyName' in this.formErrors && this.formErrors['checkout.deliveryAddress.companyName']">
                                            Dit is een verplicht veld
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-floating mb-3">
                                                <input type="text"
                                                       :class="'form-control' + ('checkout.deliveryAddress.street' in this.formErrors && this.formErrors['checkout.deliveryAddress.street'] ? ' is-invalid' : '')"
                                                       placeholder="Straat" v-model="checkout.deliveryAddress.street" id="deliveryStreet" name="deliveryStreet">
                                                <label for="deliveryStreet">Straat</label>
                                                <div class="invalid-feedback" v-if="'checkout.deliveryAddress.street' in this.formErrors && this.formErrors['checkout.deliveryAddress.street']">
                                                    Dit is een verplicht veld
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3">
                                            <div class="form-floating mb-3">
                                                <input type="text"
                                                       :class="'form-control' + ('checkout.deliveryAddress.streetNo' in this.formErrors && this.formErrors['checkout.deliveryAddress.streetNo'] ? ' is-invalid' : '')"
                                                       placeholder="(huis)nummer" v-model="checkout.deliveryAddress.streetNo" id="deliveryStreetNo"
                                                       name="deliveryStreetNo">
                                                <label for="deliveryStreetNo">(huis)nummer</label>
                                                <div class="invalid-feedback" v-if="'checkout.deliveryAddress.streetNo' in this.formErrors && this.formErrors['checkout.deliveryAddress.streetNo']">
                                                    Dit is een verplicht veld
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3">
                                            <div class="form-floating mb-3">
                                                <input type="text"
                                                       :class="'form-control' + ('checkout.deliveryAddress.streetNoAddition' in this.formErrors && this.formErrors['checkout.deliveryAddress.streetNoAddition'] ? ' is-invalid' : '')"
                                                       placeholder="Toevoeging" v-model="checkout.deliveryAddress.streetNoAddition" id="deliveryStreetNoAddition"
                                                       name="deliveryStreetNoAddition">
                                                <label for="deliveryStreetNoAddition">Toevoeging</label>
                                                <div class="invalid-feedback"
                                                     v-if="'checkout.deliveryAddress.streetNoAddition' in this.formErrors && this.formErrors['checkout.deliveryAddress.streetNoAddition']">
                                                    Dit is een verplicht veld
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="form-floating mb-3">
                                                <input type="text"
                                                       :class="'form-control' + ('checkout.deliveryAddress.streetNoAddition' in this.formErrors && this.formErrors['checkout.deliveryAddress.streetNoAddition'] ? ' is-invalid' : '')"
                                                       placeholder="Postcode" v-model="checkout.deliveryAddress.zipcode" id="deliveryZipcode"
                                                       name="deliveryZipcode">
                                                <label for="deliveryZipcode">Postcode</label>
                                                <div class="invalid-feedback" v-if="'checkout.deliveryAddress.zipcode' in this.formErrors && this.formErrors['checkout.deliveryAddress.zipcode']">
                                                    Dit is een verplicht veld
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-8">
                                            <div class="form-floating mb-3">
                                                <input type="text"
                                                       :class="'form-control' + ('checkout.deliveryAddress.city' in this.formErrors && this.formErrors['checkout.deliveryAddress.city'] ? ' is-invalid' : '')"
                                                       placeholder="Plaats" v-model="checkout.deliveryAddress.city" id="deliveryCity" name="deliveryCity">
                                                <label for="deliveryCity">Plaats</label>
                                                <div class="invalid-feedback" v-if="'checkout.deliveryAddress.city' in this.formErrors && this.formErrors['checkout.deliveryAddress.city']">
                                                    Dit is een verplicht veld
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                            <div
                                :class="'bg-secondary rounded p-2 mb-3' + ('checkout.privacyStatement' in this.formErrors && this.formErrors['checkout.privacyStatement'] ? ' border border-danger' : '')">
                                <div class="form-check">
                                    <input :class="'form-check-input' + ('checkout.privacyStatement' in this.formErrors && this.formErrors['checkout.privacyStatement'] ? ' invalid' : '')"
                                           v-model="checkout.privacyStatement" name="privacy_check" type="checkbox" value="1" id="privacyCheck">
                                    <label class="form-check-label sub" for="privacyCheck">
                                        Ik heb de <a href="/privacyverklaring">Privacyverklaring</a> gelezen en begrijp de wijze waarop mijn persoonsgegevens worden verwerkt.
                                    </label>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </div>
                <div class="modal-footer d-block">
                    <div class="modal-footer-wrapper d-flex justify-content-end" v-if="orderFormStep === 1">
                        <button class="btn btn-primary btn-sm" @click="closeCart">Verder winkelen</button>
                        <button :class="'btn btn-primary ms-auto btn-sm' + (cart.items.length <= 0 ? ' disabled' : '')" @click="orderFormStep++">Bestellen</button>
                    </div>
                    <div class="modal-footer-wrapper align-self-start d-flex justify-content-start" v-if="orderFormStep === 2">
                        <button class="btn btn-primary btn-sm" @click="orderFormStep--">Terug</button>
                        <button :class="'btn btn-primary ms-auto btn-sm' + (this.loading ? ' disabled' : '')" :disabled="this.loading" @click="completeForm">
                            <i class="fad fa-circle-notch" v-if="this.loading"></i>
                            <span v-if="!this.loading">Afrekenen</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from "bootstrap/js/src/modal";

export default {
    name:  'CartModal',
    props: ['parentUpdateQuantity', 'parentRemoveFromCart', 'cart'],
    data() {
        return {
            modal:         null,
            orderFormStep: 1,
            loading:       false,
            formErrors:    {},

            checkout: {
                firstName:        null,
                lastName:         null,
                email:            null,
                phone:            null,
                privacyStatement: false,

                invoiceAddress:  {
                    companyName:      null,
                    street:           null,
                    streetNo:         null,
                    streetNoAddition: null,
                    zipcode:          null,
                    city:             null,
                    costCenter:       null,
                },
                deliveryAddress: {
                    sameAsInvoice:    true,
                    firstName:        null,
                    lastName:         null,
                    companyName:      null,
                    street:           null,
                    streetNo:         null,
                    streetNoAddition: null,
                    zipcode:          null,
                    city:             null
                },
            }
        }
    },
    methods: {
        openCart() {
            this.modal.show();
        },
        closeCart() {
            this.modal.hide();
        },

        updateQuantity(event, cartItem) {
            return this.parentUpdateQuantity(event, cartItem)
        },

        removeFromCart(event, key) {
            return this.parentRemoveFromCart(event, key);
        },

        completeForm() {
            this.loading    = true;
            this.formErrors = {};

            const post = {
                cart:     this.cart,
                checkout: this.checkout
            }

            const formData = new FormData();
            formData.append('post', JSON.stringify(post));

            const vm = this;
            axios.post('/api/checkout', formData).then((response) => {
                if(response.data.redirect) {
                    window.location = response.data.redirect;
                }
            }).catch((exception) => {
                vm.formErrors = exception.response.data.errors;
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        this.modal = new Modal(
            document.querySelector('#cartModal')
        );
    }
}
</script>
